import {
  GET_PATIENTS,
  GET_PATIENTS_FAILURE,
  GET_PATIENTS_SUCCESS,
  GET_PATIENT,
  GET_PATIENT_FAILURE,
  GET_PATIENT_SUCCESS,
  GET_PERFORMAONE,
  GET_PERFORMAONE_FAILURE,
  GET_PERFORMAONE_SUCCESS,
  GET_DISORDER_ANS_TREATMENT,
  GET_DISORDER_ANS_TREATMENT_FAILURE,
  GET_DISORDER_ANS_TREATMENT_SUCCESS,
  GET_SCANS,
  GET_SCANS_FAILURE,
  GET_SCANS_SUCCESS,
  GET_XRAY,
  GET_XRAY_FAILURE,
  GET_XRAY_SUCCESS,
  GET_CLINICAL_FEATURE,
  GET_CLINICAL_FEATURE_FAILURE,
  GET_CLINICAL_FEATURE_SUCCESS,
  GET_DEXA,
  GET_DEXA_FAILURE,
  GET_DEXA_SUCCESS,
  GET_DEXA1,
  GET_DEXA1_FAILURE,
  GET_DEXA1_SUCCESS,
  GET_DEXA3,
  GET_DEXA3_FAILURE,
  GET_DEXA3_SUCCESS,
  GET_INVESTIGATION,
  GET_INVESTIGATION_FAILURE,
  GET_INVESTIGATION_SUCCESS,
  GET_HRPQCT_SUCCESS,
  GET_HRPQCT_FAILURE,
  GET_HRPQCT,
  RESET_XRAY_STATE,
  RESET_SCAN_STATE,
  RESET_DEXA1_STATE,
  RESET_DEXA3_STATE,
  RESET_DISORDER_ANS_TREATMENT_STATE,
  RESET_INVESTIGATION_STATE,
  RESET_PATIENT_STATE,
  RESET_CLINICAL_FEATURE_STATE,
  RESET_DEXA_STATE,
  RESET_GET_PERFORMAONE_STATE,
} from "../Utils/Constants";

export const getPatients = (payload) => {
  return {
    type: GET_PATIENTS,
    payload: payload,
  };
};

export const getPatientsFailure = (payload) => {
  return {
    type: GET_PATIENTS_FAILURE,
    payload: payload,
  };
};

export const getPatientsSuccess = (payload) => {
  return {
    type: GET_PATIENTS_SUCCESS,
    payload: payload,
  };
};

export const getPatient = (payload) => {
  return {
    type: GET_PATIENT,
    payload: payload,
  };
};

export const getPatientFailure = (payload) => {
  return {
    type: GET_PATIENT_FAILURE,
    payload: payload,
  };
};

export const getPatientSuccess = (payload) => {
  return {
    type: GET_PATIENT_SUCCESS,
    payload: payload,
  };
};

export const getPerformaOne = (payload) => {
  return {
    type: GET_PERFORMAONE,
    payload: payload,
  };
};

export const getPerformaOneFailure = (payload) => {
  return {
    type: GET_PERFORMAONE_FAILURE,
    payload: payload,
  };
};

export const getPerformaOneSuccess = (payload) => {
  return {
    type: GET_PERFORMAONE_SUCCESS,
    payload: payload,
  };
};

export const getScans = (payload) => {
  return {
    type: GET_SCANS,
    payload: payload,
  };
};

export const getScansFailure = (payload) => {
  return {
    type: GET_SCANS_FAILURE,
    payload: payload,
  };
};

export const getScansSuccess = (payload) => {
  return {
    type: GET_SCANS_SUCCESS,
    payload: payload,
  };
};

export const getXray = (payload) => {
  return {
    type: GET_XRAY,
    payload: payload,
  };
};

export const getXrayFailure = (payload) => {
  return {
    type: GET_XRAY_FAILURE,
    payload: payload,
  };
};

export const getXraySuccess = (payload) => {
  return {
    type: GET_XRAY_SUCCESS,
    payload: payload,
  };
};

export const getDisorderAndTreatment = (payload) => {
  return {
    type: GET_DISORDER_ANS_TREATMENT,
    payload: payload,
  };
};

export const getDisorderAndTreatmentFailure = (payload) => {
  return {
    type: GET_DISORDER_ANS_TREATMENT_FAILURE,
    payload: payload,
  };
};

export const getDisorderAndTreatmentSuccess = (payload) => {
  const { data } = payload;
  const disorderDifferentiator = "🡸Disorder||Treatment🡺";

  const combinedString = data.treatment || "";
  const splitIndex = combinedString.indexOf(disorderDifferentiator);

  if (splitIndex !== -1) {
    const treatment = combinedString.substring(0, splitIndex);
    const remarks = combinedString.substring(
      splitIndex + disorderDifferentiator.length
    );
    data.treatment = treatment || "";
    data.remarks = remarks || "";
  } else {
    data.treatment = combinedString;
    data.remarks = "";
  }
  // sessionStorage.setItem("disorder",data)
  // console.log(JSON.stringify(data)+"bagal wagal")
  return {
    type: GET_DISORDER_ANS_TREATMENT_SUCCESS,
    payload: {
      ...payload,
      data: {
        ...data,
      },
    },
  };
};

export const getClinicalFeatures = (payload) => {
  return {
    type: GET_CLINICAL_FEATURE,
    payload: payload,
  };
};

export const getClinicalFeatureFailure = (payload) => {
  return {
    type: GET_CLINICAL_FEATURE_FAILURE,
    payload: payload,
  };
};

export const getClinicalFeatureSuccess = (payload) => {
  return {
    type: GET_CLINICAL_FEATURE_SUCCESS,
    payload: payload,
  };
};

export const getInvestigation = (payload) => {
  return {
    type: GET_INVESTIGATION,
    payload: payload,
  };
};

export const getInvestigationFailure = (payload) => {
  return {
    type: GET_INVESTIGATION_FAILURE,
    payload: payload,
  };
};

export const getInvestigationSuccess = (payload) => {
  return {
    type: GET_INVESTIGATION_SUCCESS,
    payload: payload,
  };
};

export const getDexa = (payload) => {
  return {
    type: GET_DEXA,
    payload: payload,
  };
};

export const getDexaFailure = (payload) => {
  return {
    type: GET_DEXA_FAILURE,
    payload: payload,
  };
};

export const getDexaSuccess = (payload) => {
  return {
    type: GET_DEXA_SUCCESS,
    payload: payload,
  };
};

export const getDexa1 = (payload) => {
  return {
    type: GET_DEXA1,
    payload: payload,
  };
};

export const getDexa1Failure = (payload) => {
  return {
    type: GET_DEXA1_FAILURE,
    payload: payload,
  };
};

export const getDexa1Success = (payload) => {
  return {
    type: GET_DEXA1_SUCCESS,
    payload: payload,
  };
};

export const getDexa3 = (payload) => {
  return {
    type: GET_DEXA3,
    payload: payload,
  };
};

export const getDexa3Failure = (payload) => {
  return {
    type: GET_DEXA3_FAILURE,
    payload: payload,
  };
};

export const getDexa3Success = (payload) => {
  return {
    type: GET_DEXA3_SUCCESS,
    payload: payload,
  };
};
export const getHrpqct = (payload) => {
  return {
    type: GET_HRPQCT,
    payload: payload,
  };
};
export const getHrpqctFailure = (payload) => {
  return {
    type: GET_HRPQCT_FAILURE,
    payload: payload,
  };
};

export const getHrpqctSuccess = (payload) => {
  return {
    type: GET_HRPQCT_SUCCESS,
    payload: payload,
  };
};
export const resetScanState = () => {
  return {
    type: RESET_SCAN_STATE,
  };
};
export const resetXrayState = () => {
  return {
    type: RESET_XRAY_STATE,
  };
};
export const resetDexa1State = () => {
  return {
    type: RESET_DEXA1_STATE,
  };
};
export const resetDexa3State = () => {
  return {
    type: RESET_DEXA3_STATE,
  };
};
export const resetDisorderTreatmentState = () => {
  return {
    type: RESET_DISORDER_ANS_TREATMENT_STATE,
  };
};
export const resetInvestigationState = () => {
  return {
    type: RESET_INVESTIGATION_STATE,
  };
};
export const resetClinicalFeatureState = () => {
  return {
    type: RESET_CLINICAL_FEATURE_STATE,
  };
};
export const resetDexaState = () => {
  return {
    type: RESET_DEXA_STATE,
  };
};
export const resetGetPerformaOneState = () => {
  return {
    type: RESET_GET_PERFORMAONE_STATE,
  };
};
export const resetPatientState = () => {
  return {
    type: RESET_PATIENT_STATE,
  };
};